import { generatePath, Navigate } from 'react-router';

import { PATH } from '../../appRouter/url.js';
import { ContentLoading } from '../../components/general/ContentLoading.js';
import { FailedQueryAlert } from '../../components/general/ErrorAlert.js';
import { NoContentInfo } from '../../components/general/NoContentInfo.js';
import { useNormalizedParams } from '../../hooks/useNormalizedParams.js';
import { trpc } from '../../trpc.js';

/**
 * Redirect to a Thema Details page by Aka-Thema-Id when only an Aka-Produkt-Id is available
 */
export const ThemaDetailsRedirectByAkaProduktId = () => {
  const { akaProduktId } = useNormalizedParams();

  if (akaProduktId === undefined) {
    throw new TypeError('Die Aka-Produkt-Id fehlt in der URL.');
  }

  const themaQuery = trpc.thema.getAkaThemaIdByAkaProductId.useQuery(akaProduktId);

  if (themaQuery.error && themaQuery.error.data?.code !== 'NOT_FOUND') {
    return <FailedQueryAlert error={themaQuery.error} query="Thema" />;
  }

  if (themaQuery.isLoading) {
    return <ContentLoading />;
  }

  const akaThemaId = themaQuery.data;

  if (!akaThemaId) {
    return <NoContentInfo content="Kein Thema gefunden" />;
  }

  return <Navigate to={generatePath(PATH.THEMA.DETAILS, { akaThemaId })} replace />;
};
